import { render, staticRenderFns } from "./UploadCsds.vue?vue&type=template&id=a087be20&scoped=true&"
import script from "./UploadCsds.vue?vue&type=script&lang=js&"
export * from "./UploadCsds.vue?vue&type=script&lang=js&"
import style0 from "./UploadCsds.vue?vue&type=style&index=0&id=a087be20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a087be20",
  null
  
)

export default component.exports